import { useContext } from "react";
import { useCountries } from "hooks";
import QueryContext from "state/query";
import DropdownSelect from "./DropdownSelect";
import { faFlag } from "@fortawesome/pro-light-svg-icons";
import { faFlag as solidFlag } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import s from "./filter.module.css";

const SelectCountries = () => {
  const { countries } = useCountries();
  const { countries: selectedCountries, setCountries } =
    useContext(QueryContext);

  return (
    <div className="relative h-full grow text-center group">
      <DropdownSelect
        title="Countries"
        value={selectedCountries}
        options={countries}
        onChange={setCountries}
        icon={<FontAwesomeIcon icon={faFlag} className={`${s.icon} group-hover:hidden`}/>}
        iconHover={<FontAwesomeIcon icon={solidFlag} className={`${s.icon} hidden group-hover:inline-block`}/>}
      />
    </div>
  );
};

export default SelectCountries;
